module.exports = __webpack_public_path__ + "img/hsjy.d5c4148d.png";